export default __webpack_public_path__ + "static/media/morelo.ec81f547.png";